var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.cancelar()}}},[_c('v-icon',[_vm._v("mdi-cancel")]),_vm._v(" Cancelar ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }